import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import uiSlice from 'store/modules/ui';

let displayed = [];

function Notifier() {
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const notifications = useSelector((state) => state.ui.notifications, shallowEqual);

  const storeDisplayed = (id) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  useEffect(() => {
    // La cola quedó vacía de golpe: es el PURGE del logout. notistack vive por ENCIMA del
    // router, así que sin este cierre el toast que estaba en pantalla (y los que quedaran
    // encolados por `maxSnack`) sobrevivían a la navegación y reaparecían en el login.
    if (notifications.length === 0) {
      displayed.forEach((key) => closeSnackbar(key));
      displayed = [];
      return;
    }

    notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
      if (dismissed) {
        closeSnackbar(key);
        return;
      }

      // Nunca renderizar una barra vacía: si el mensaje viene nulo/en blanco (p. ej. un
      // error que el interceptor decidió silenciar), se descarta del estado y listo.
      if (!message || !String(message).trim()) {
        dispatch(uiSlice.actions.removeSnackbar(key));
        return;
      }

      if (displayed.includes(key)) return;

      enqueueSnackbar(message, {
        key,
        ...options,
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        onExited: (event, myKey) => {
          dispatch(uiSlice.actions.removeSnackbar(myKey));
          removeDisplayed(myKey);
        }
      });

      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
}

export default Notifier;
